import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function OvertimeCSVPreviewHeader() {}

OvertimeCSVPreviewHeader.prototype = new CSVPreviewSection()

OvertimeCSVPreviewHeader.prototype.init = function(firstGroupingLevel, secondGroupingLevel) {
    CSVPreviewSection.prototype.init.call(this)
    this.firstGroupingLevel = firstGroupingLevel
    this.secondGroupingLevel = secondGroupingLevel
    return this
}

OvertimeCSVPreviewHeader.prototype.addRows = function(tBody, columnNames) {
    const mainHeaderRow = this.createRow("headerRow")
    ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel))

    if (this.secondGroupingLevel !== ReportGroupingLevel.NONE) {
        ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel))
    }

    const self = this
    _.each(columnNames, function(name) {self.addCell(mainHeaderRow, name)})

    this.addRow(tBody, mainHeaderRow)
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/overtime/OvertimeCSVPreviewHeader.js